import { useConfig } from '@/default-config';

import { Card, CardType, CreditCard } from '@generated-types';

import { CreditCardService } from '../CreditCard';

const stringListToArray = (str: string | undefined) => {
    if (!str) {
        return [];
    }
    return str.split(',');
};

export const useCanCardUseNewPinService = (card: Card | CreditCard) => {
    const { setup } = useConfig();
    const isV4 = CreditCardService.isCreditCard(card);

    return (
        !isV4 &&
        card.type === CardType.DEBIT &&
        stringListToArray(setup.newPinBanks).includes(card.bankRegistrationNumber)
    );
};
